import { string } from 'prop-types';
import React from 'react';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const VerificationIcon = ({ color, height, viewBox, width, ...rest }) => {
    return (
        <SvgIcon width={width} height={height} viewBox={viewBox} {...rest}>
            <path
                fill={color}
                d="M24,12l-2.66-3.04.37-4.03-3.94-.89-2.06-3.49-3.71,1.59-3.71-1.59-2.06,3.48-3.94.88.37,4.04-2.66,3.05,2.66,3.04-.37,4.04,3.94.89,2.06,3.48,3.71-1.6,3.71,1.59,2.06-3.48,3.94-.89-.37-4.03,2.66-3.04ZM9.92,17.15l-4.15-4.16,1.61-1.61,2.53,2.54,6.38-6.4,1.61,1.61-8,8.02Z"
            />
        </SvgIcon>
    );
};

VerificationIcon.propTypes = {
    color: string,
    height: string,
    viewBox: string,
    width: string,
};

VerificationIcon.defaultProps = {
    color: MIGRATED_COLORS.black,
    height: '24px',
    viewBox: '0 0 24 24',
    width: '24px',
};

export default VerificationIcon;
